import { Avatar, AvatarImage } from "../ui/avatar";
import { Card, CardContent } from "../ui/card";

interface Props {
  avatar: string;
  text: string;
  text1: string;
  desc: string;
}

export const FrameThree = ({
  avatar,
  text = "Erik Linquier",
  text1 = "Président",
  desc = "",
}: Props): JSX.Element => {
  return (
    <Card className="h-full transition-shadow border-none shadow-sm bg-white hover:shadow-md">
      <CardContent className="flex flex-col items-center justify-center h-full p-6 space-y-3 text-center">
        <Avatar className="w-20 h-20 ring-2 ring-primary/20 ring-offset-2">
          <AvatarImage
            alt={text}
            src={avatar}
            className="object-cover object-top"
          />
        </Avatar>
        <div className="space-y-1">
          <h3 className="text-sm font-semibold text-[#242424]">{text}</h3>
          <h6 className="text-sm font-medium text-primary">{text1}</h6>
          {desc && (
            <p className="text-xs leading-5 text-gray-500">{desc}</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
